import React, { FC } from 'react'
import cx from 'classnames'
import { DivProps } from '@commonTypes'
import css from './filterContainer.module.scss'

const FilterContainer: FC<React.PropsWithChildren<DivProps>> = ({ className, ...props }) => {
  return <div className={cx(css.container, className)} {...props} />
}

export default FilterContainer
